import { useEffect, useState } from "react";

export default function JobStatus({ status }) {
  const [jobStatus, setJobStatus] = useState({
    status: "Open",
    color: "#28DDCF",
  });

  useEffect(() => {
    if (status === 2) {
      setJobStatus((prev) => ({
        status: "Closed",
        color: "#FF6633",
      }));
    } else if (status === 1) {
      setJobStatus((prev) => ({
        status: "In Review",
        color: "#FCE80F",
      }));
    }
  }, [status]);

  return (
    <>
      <div className="job-card-status">
        <p>
          Job status
          <span style={{ backgroundColor: jobStatus.color }}>
            {jobStatus.status}
          </span>
        </p>
      </div>
    </>
  );
}
